import { render, staticRenderFns } from "./investmentManagerModal.vue?vue&type=template&id=ece9d93e&"
import script from "./investmentManagerModal.vue?vue&type=script&lang=js&"
export * from "./investmentManagerModal.vue?vue&type=script&lang=js&"
import style0 from "./investmentManagerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports